import { render, staticRenderFns } from "./ThoughtNavController.vue?vue&type=template&id=60c5746f&scoped=true"
import script from "./ThoughtNavController.vue?vue&type=script&lang=js"
export * from "./ThoughtNavController.vue?vue&type=script&lang=js"
import style0 from "./ThoughtNavController.vue?vue&type=style&index=0&id=60c5746f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c5746f",
  null
  
)

export default component.exports